import { apiClient } from '@/lib/api/api-client'
import type { FilterOption } from '@/lib/api/types'

export const apiGetSiteWorksPartners = () =>
  apiClient<FilterOption[]>('/api/v1/site-works-partners')
